import { NodeTypeName } from "@app/types";
import BaseNodeModel from "../BaseNodeModel";


const referenceTypeOptions = [
    {
      value: "prompt",
      name: "Prompt",
      default: true
    },
    {
      value: "variable",
      name: "Variable",
    },
  ];

export default class PromptReferenceNodeModel extends BaseNodeModel {
  /**
   * Prompt reference node model
   * @module PromptReferenceNodeModel
   * @param {string} nodeName Node display name
   * @param {number} x Node x coordinate on canvas
   * @param {number} y Node y coordinate on canvas
   * @param {Object} props Pre-defined node properties; if non-null, apply values to node properties
   * @param {string} id If non-null, use this ID as the node ID
   */

  constructor(
    nodeName = "UNTITLED_NODE",
    x = 0,
    y = 0,
    props = null,
    id = null
  ) {
    super(nodeName, x, y, null, id);
    this.props.nodeTypeName = NodeTypeName.promptReference;
    this.props.colorClass = "orange";
    this.props.iconClass = "shuffle";
    this.DEFAULT_COLOR_CLASS = "orange";
    this.applyProps(props);
    // default referenceType
    this.props.config.referenceType = this.props.config.referenceType || "prompt";
    // default node description
    this.props.config.description = this.props.config.description || "Prompt Reference Node";
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.config.referenceType !== this.props.config.referenceType) {
      this.props.config.referenceType = nextProps.config.referenceType;
      document.dispatchEvent(new CustomEvent("ev-property-refresh"));
    }
  }

  getConfig(key) {
    return super.getConfig(key);
  }

  setConfig(key, value) {
    if (key === "referenceType") {
      if (this.props.config.referenceType !== value) {
        this.props.config.referenceType = value;
        this.props.lastLocalChange = window.apm.timestamp;
        document.dispatchEvent(new CustomEvent("ev-property-refresh"));
      }
    }

    if (key === "promptReference") {
      this.props.config.promptReference = value;
    }

    if (key === "variableReference") {
      this.props.config.variableReference = value;
    }

    super.setConfig(key, value);
  }

  getInputForReference() {
    return [
      {
        type: "Input",
        label: "Reference",
        key: "promptReference",
        valKey: "promptReference",
        suggestion: "prompt",
        isHidden: this.props.config.referenceType !== "prompt" ? true : false,
      },
      {
        type: "Input",
        label: "Reference",
        key: "variableReference",
        valKey: "variableReference",
        suggestion: "variable",
        isHidden: this.props.config.referenceType !== "variable" ? true : false,
      },
    ];
  }

  getKeyForReferenceInput() {
    if (
      !this.props.config.referenceType ||
      this.props.config.referenceType === "prompt"
    ) {
      return "promptReference";
    }
    if (this.props.config.referenceType === "variable") {
      return "variableReference";
    }
  }

  getInputSuggestionType() {
    return this.props.config.referenceType;
  }

  getConfigViews() {
    const configView = [
      {
        type: "Textarea",
        label: this.getPropLabel("description"),
        key: "description",
      },
      {
        type: "hr",
      },
      {
        type: "Label",
        labelName: this.getPropLabel("prompt_reference"),
      },
      {
        type: "Dropdown",
        label: "Type",
        key: "referenceType",
        options: referenceTypeOptions,
        optionName: "Select a Type",
      },
    ];
    return [
      ...this.getConfigViewNameField(),
      ...configView,
      ...this.getInputForReference(),
      ...[
        { type: "hr" },
        {
          type: "Textarea",
          label: this.getPropLabel("note"),
          key: "note",
        },
      ],
    ];
  }
}